<template>
  <div
    :id="cardId"
    class="mdl-card mdl-shadow--2dp"
    style="margin-top: 1em;">
    <div
      :style="{ background: unansweredBackground }"
      class="mdl-card__title unanswered">

      <div
        class="ui top right attached label"
        style="background-color: rgba(38, 61, 75, 0.7); color: white; text-shadow: none;">
        <span v-if="showResults===true">{{ localization.surveyCardComponent.answerAvailableText }}</span>
        <span v-else>
          {{ localization.surveyCardComponent.answerUnavailableText }} {{ resultsDateText }}
        </span>

      </div>

      <h2 class="mdl-card__title-text"> {{ qnResponseSingle.card_title }} </h2>
    </div>

    <!--<div-->
      <!--class="ui bottom attached mini inverted message"-->
      <!--style="background-color: #1f2833; opacity:0.9;margin-bottom:0;padding-bottom:0;">-->

      <!--<i class="ui idea icon"></i>-->
      <!--{{ qnResponseSingle.card_short_blurb }}-->
    <!--</div>-->

    <div class="mdl-card__supporting-text">
      {{ qnResponseSingle.card_description }}
    </div>

    <div
      class="mdl-card__actions mdl-card--border"
      style="padding-bottom:1.25em;">

      <button
        :id="startSurveyButtonId"
        class="ui fluid big button"
        style="background-color: #F38F24; color: white;"
        @touchstart="openTypeformLink">
        {{ localization.actionButtonText.startButton }} <i class="right chevron icon"/>
      </button>

      <button
        :id="linkLoadingButtonId"
        class="ui fluid big button"
        style="background-color: #F38F24; display:none;">
        <i class="inverted spinner loading icon" style="margin: 0;"></i>
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'UnansweredSurvey',
  props: {
    qnResponseSingle: {
      type: Object,
      required: true
    },
    formId: {
      type: String,
      required: true
    },
    minUnansweredIndex: {
      type: Number,
      required: false,
      default: () => {
        return -1;
      }
    }
  },
  data () {
    return {
      cardId: 'unanswered' + this._uid,
      startSurveyButtonId: 'startSurveyButtonId' + this._uid,
      linkLoadingButtonId: 'linkLoadingButton' + this._uid,
      resultsMinResponse: 1
    };
  },
  computed: {
    unansweredBackground: function () {
      return 'linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, #04afb9 160%), url(' + this.qnResponseSingle.image_link + ') center / cover';
    },
    typeformLink () {
      return 'https://healint.typeform.com/to/' + this.formId + '?userid=' + this.userId + '&lang=' + this.userLang + '&version=' + process.env.NODE_ENV + '&country=' + this.userCountry;
    },
    resultsDate () {
      return this.qnResponseSingle.unlock_date;
    },
    resultsDateText () {
      let date = new Date(this.resultsDate);
      let locale = this.userLang + '-' + this.userCountry;

      return date.toLocaleString(locale, {timeZone: 'UTC', month: 'short', day: 'numeric'});
    },
    showResults () {
      if (this.qnResponseSingle.unlock_date === null || new Date() > new Date(this.qnResponseSingle.unlock_date)) {
        return true;
      } else {
        return false;
      }
    }

  },
  mounted () {
    if (this.$route.name === 'Home' && this.minUnansweredIndex !== -1) {
      this.scrollToFirstUnanswered();
    }
  },

  methods: {

    scrollToFirstUnanswered: function () {
      if (this.$vnode.key === this.minUnansweredIndex &&
          document.getElementsByClassName('mdl-card').length === this.qnResponseOverall.length) {

        // No scollIntoView because it is EXPERIMENTAL tech. Using https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect instead
        // Scroll to first unanswered but offsetting by 3em (i.e. height of the top nav bar)
        let offsetNavBarHeight = parseFloat(getComputedStyle(document.getElementById('app')).fontSize) * 4;

        window.scroll({
          top: document.getElementById(this.cardId).getBoundingClientRect().top - offsetNavBarHeight,
          left: 0,
          behavior: 'smooth'
        });
      }
    },

    openTypeformLink () {
      document.getElementById(this.startSurveyButtonId).style.display = 'none';
      document.getElementById(this.linkLoadingButtonId).style.display = 'block';

      amplitude.getInstance().setUserProperties({'QuestionnaireBuddyStart': true});
      amplitude.getInstance().logEvent('QB - Start Questionnaire', {'Start': this.formId});

      // TODO: To make this be using openUrl if possible! :)

      window.setTimeout(() => {
        window.location.href = this.typeformLink;
      }, 300);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/survey/onetime/UnansweredSurvey.vue